__turbopack_context__.v({
  "fillWidth": "o_-VSa_fillWidth",
  "header": "o_-VSa_header",
  "pagination": "o_-VSa_pagination",
  "root": "o_-VSa_root",
  "row": "o_-VSa_row",
  "table": "o_-VSa_table",
});
